/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RetrieveCheckoutRequest = {
  /**
   * The ID of the checkout session to retrieve.
   */
  checkoutId: string;
};

/** @internal */
export const RetrieveCheckoutRequest$inboundSchema: z.ZodType<
  RetrieveCheckoutRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  checkout_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "checkout_id": "checkoutId",
  });
});
/** @internal */
export type RetrieveCheckoutRequest$Outbound = {
  checkout_id: string;
};

/** @internal */
export const RetrieveCheckoutRequest$outboundSchema: z.ZodType<
  RetrieveCheckoutRequest$Outbound,
  z.ZodTypeDef,
  RetrieveCheckoutRequest
> = z.object({
  checkoutId: z.string(),
}).transform((v) => {
  return remap$(v, {
    checkoutId: "checkout_id",
  });
});

export function retrieveCheckoutRequestToJSON(
  retrieveCheckoutRequest: RetrieveCheckoutRequest,
): string {
  return JSON.stringify(
    RetrieveCheckoutRequest$outboundSchema.parse(retrieveCheckoutRequest),
  );
}
export function retrieveCheckoutRequestFromJSON(
  jsonString: string,
): SafeParseResult<RetrieveCheckoutRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RetrieveCheckoutRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RetrieveCheckoutRequest' from JSON`,
  );
}
